import http from 'plugins/axios'

export default {
  getUserList({ page, size, userId, startTime = '', endTime = '' }) {
    return http.get({
      url: `/ta/admin/send/coin/getList?page=${page}&size=${size}&userId=${userId}&startTime=${startTime}&endTime=${endTime}`,
    })
  },
  sendCoin(data) {
    return http.post({
      url: `/ta/admin/send/coin/sendCoin`,
      data,
    })
  },
  supportedCoins() {
    return http.get({
      url: `/ta/admin/send/coin/supportedCoins`,
    })
  },
  publicBalance(coin) {
    return http.get({
      url: `/ta/admin/send/coin/publicBalance?coin=${coin}`,
    })
  },
  upgradePartner({ userId, channelId, rate }) {
    return http.post({
      url: `/channel/partner/addChannel?channelId=${channelId}&userId=${userId}&rate=${rate}`,
    })
  },
  upgradeRate({ userId, channelId, rate, spotRate }) {
    const params = [
      `channelId=${channelId}`,
      `userId=${userId}`,
      `rate=${rate}`,
    ]
    if (spotRate !== undefined && spotRate !== '' && spotRate !== null) {
      params.push(`spotRate=${spotRate}`)
    }
    return http.post({
      url: `/channel/partner/rebateRate?${params.join('&')}`,
    })
  },
  getTotalInfo(data) {
    return http.get({
      url: `/ta/admin/send/coin/getListTotal`,
      data,
    })
  },
}
